import styled from 'styled-components';
import { IoClose } from 'react-icons/io5';
import {
  subMenuDropdownBackground,
  primaryColorLight,
  primaryColorWeak,
  outlineGray,
} from '../../config/colors';
import Button from '../Button';

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: ${subMenuDropdownBackground};
  padding: 20px 30px;
`;

export const TableTitle = styled.input`
  height: 40px;
  margin-bottom: 35px;
  margin-right: 60px;
  border: 2px solid ${outlineGray};
  border-radius: 3px;
  padding: 5px 10px;
  font-size: 0.875rem;
  text-align: start;
`;

export const TableWrapper = styled.div`
  width: 100%;
  font-size: 0.688rem;
  font-weight: 700;
  table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    border-collapse: collapse;
    table-layout: fixed;
    word-break: break-word;

    colgroup {
      col:nth-child(1) {
        width: 6%
      }
      col:nth-child(2) {
        width: 25%
      }
      col:nth-child(5) {
        width: 13%
      }
      col:nth-child(6) {
        width: 15%
      }
    }
    
    td,
    th {
      border: 2px solid ${primaryColorLight};
    }
    th {
      padding: 10px;
      background-color: ${primaryColorWeak};
      font-size: 0.875rem;
    }

    thead {
      tr:nth-child(2) > th,
      tr:nth-child(3) > th {
        background-color: whiteSmoke;
        padding: 5px;
        font-size: 0.688rem;
        font-weight: 700;
      }

      th:last-child,
      tr:nth-child(2) > th:last-child,
      tr:nth-child(3) > th:last-child {
        border: 0px;
        background-color: ${subMenuDropdownBackground};
      }
    }

    tbody {
      background-color: white;

      tr {
        td:first-child {
          width: 7%;
        }

        td:last-child {
          width: 3%;
          border: 0px;
          background-color: ${subMenuDropdownBackground};
        }
      }
    }
  }
`;

export const RemoveRowBtn = styled(Button).attrs({
  wrapperStyle: {
    width: '25px',
    height: '25px',
  },
  type: 'rounded',
  icon: IoClose,
  iconProps: {
    color: 'white',
    size: '16px',
  },
})``;

export const AddNewRowBtn = styled(Button).attrs({
  wrapperStyle: {
    width: '60%',
    height: '40px',
    alignSelf: 'center',
    marginTop: '20px',
    marginBottom: '20px'
  },
  textStyle: {
    fontSize: '1rem',
  },
})``;

export const EditComment = styled.input`
  width: 100%;
  height: 40px;
  border: 2px solid ${outlineGray};
  border-radius: 3px;
  padding: 5px 10px;
  font-size: 1rem;
  text-align: start;
  margin-top: 20px;
  margin-bottom: 50px;
`;
